
  /**
   * @license
   * author: shanxian_dev
   * kk_custom_ui.js v1.0.1
   * Released under the ISC license.
   */

import hexToRgba from 'hex-to-rgba';
import { create, SheetsRegistry } from 'jss';
import camelCase from 'jss-plugin-camel-case';
import nested from 'jss-plugin-nested';
import vendorPrefixer from 'jss-plugin-vendor-prefixer';
import md5 from 'js-md5';
import { camelizeKeys } from 'humps';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function px$1(num) {
  return "".concat(num / 2, "px");
}

var TPL_KEY = 'vars';
var PropertyNode = /*#__PURE__*/function () {
  function PropertyNode(node, root) {
    _classCallCheck(this, PropertyNode);

    var _a;

    var data = {};

    for (var _i = 0, _Object$keys = Object.keys(node); _i < _Object$keys.length; _i++) {
      var k = _Object$keys[_i];

      if (k in PropertyNode.abbrMap) {
        var key = PropertyNode.abbrMap[k];
        data[key] = (_a = node[key]) !== null && _a !== void 0 ? _a : node[k];
      } else {
        data[k] = node[k];
      }
    }

    if (!root) {
      this.node = data;
      this.root = node;
    } else {
      this.root = root;

      if (data[TPL_KEY] && root[TPL_KEY]) {
        var variables = data[TPL_KEY];
        var rootVars = root[TPL_KEY];

        var _iterator = _createForOfIteratorHelper(variables),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var varName = _step.value;

            if (typeof varName !== 'string') {
              throw Error('variables name must be String');
            }

            if (varName === TPL_KEY) {
              continue;
            }

            if (Object.prototype.hasOwnProperty.call(rootVars, varName)) {
              (function () {
                var content = rootVars[varName];
                Object.keys(content).forEach(function (k) {
                  var _a;

                  var key = (_a = PropertyNode.abbrMap[k]) !== null && _a !== void 0 ? _a : k;

                  if (!Object.prototype.hasOwnProperty.call(data, key)) {
                    data[key] = content[k];
                  }
                });
              })();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      this.node = data;
    }
  }

  _createClass(PropertyNode, [{
    key: "get",
    value: function get(key) {
      var _this = this;

      var v = this.node[key];

      if (Array.isArray(v)) {
        return v.map(function (a) {
          if (_typeof(a) === 'object') {
            return new PropertyNode(a, _this.root);
          }

          return a;
        });
      }

      if (_typeof(v) === 'object') {
        return new PropertyNode(v, this.root);
      }

      return v;
    }
  }, {
    key: "toMap",
    value: function toMap() {
      return this.node;
    }
  }]);

  return PropertyNode;
}();
PropertyNode.abbrMap = {
  t: 'type',
  w: 'width',
  h: 'height',
  pd: 'padding',
  mg: 'margin',
  fs: 'fontSize',
  mAA: 'mainAxisAlignment',
  cAA: 'crossAxisAlignment',
  bg: 'background',
  bdR: 'borderRadius',
  bd: 'border',
  tl: 'top-left',
  tr: 'top-right',
  bl: 'bottom-left',
  br: 'bottom-right',
  cd: 'child',
  cdr: 'children',
  fS: 'fontSize',
  fW: 'fontWeight',
  lH: 'lineHeight',
  ct: 'content'
};
var PropertyConvert = /*#__PURE__*/function () {
  function PropertyConvert() {
    _classCallCheck(this, PropertyConvert);
  }

  _createClass(PropertyConvert, null, [{
    key: "paddingValue",
    value: function paddingValue(padding) {
      var _a, _b, _c, _d, _e, _f, _g, _h;

      var top = (_b = (_a = padding.get('top')) !== null && _a !== void 0 ? _a : padding.get('all')) !== null && _b !== void 0 ? _b : 0;
      var right = (_d = (_c = padding.get('right')) !== null && _c !== void 0 ? _c : padding.get('all')) !== null && _d !== void 0 ? _d : 0;
      var bottom = (_f = (_e = padding.get('bottom')) !== null && _e !== void 0 ? _e : padding.get('all')) !== null && _f !== void 0 ? _f : 0;
      var left = (_h = (_g = padding.get('left')) !== null && _g !== void 0 ? _g : padding.get('all')) !== null && _h !== void 0 ? _h : 0;
      return "".concat(px$1(top), " ").concat(px$1(right), " ").concat(px$1(bottom), " ").concat(px$1(left));
    }
  }, {
    key: "marginValue",
    value: function marginValue(margin) {
      return this.paddingValue(margin);
    }
  }, {
    key: "getColor",
    value: function getColor(colorValue) {
      return colorValue !== null && colorValue !== void 0 ? colorValue : '#FFFFFF';
    }
  }, {
    key: "borderValue",
    value: function borderValue(border) {
      var _a;

      if (border) {
        var width = (_a = border.get('width')) !== null && _a !== void 0 ? _a : 0;
        var color = this.getColor(border.get('color'));
        return "".concat(px$1(width), " solid ").concat(color);
      }

      return '';
    }
  }, {
    key: "borderRadiusValue",
    value: function borderRadiusValue(borderRadius) {
      var _a, _b, _c, _d, _e, _f, _g, _h;

      var tl = (_b = (_a = borderRadius.get('top-left')) !== null && _a !== void 0 ? _a : borderRadius.get('all')) !== null && _b !== void 0 ? _b : 0;
      var tr = (_d = (_c = borderRadius.get('top-right')) !== null && _c !== void 0 ? _c : borderRadius.get('all')) !== null && _d !== void 0 ? _d : 0;
      var bl = (_f = (_e = borderRadius.get('bottom-left')) !== null && _e !== void 0 ? _e : borderRadius.get('all')) !== null && _f !== void 0 ? _f : 0;
      var br = (_h = (_g = borderRadius.get('bottom-right')) !== null && _g !== void 0 ? _g : borderRadius.get('all')) !== null && _h !== void 0 ? _h : 0;
      return "".concat(px$1(tl), " ").concat(px$1(tr), " ").concat(px$1(br), " ").concat(px$1(bl));
    }
  }, {
    key: "hexAToRGBA",
    value: function hexAToRGBA(hex) {
      return hexToRgba(hex);
    }
  }, {
    key: "fitValue",
    value: function fitValue(fit) {
      var result = '100% 100%';

      switch (fit) {
        case 'cover':
          {
            result = 'cover';
            break;
          }

        case 'contain':
          {
            result = 'contain';
            break;
          }
      }

      return result;
    }
  }, {
    key: "justifyContent",
    value: function justifyContent(mainAxisAligment) {
      switch (mainAxisAligment) {
        case 'start':
          return 'start';

        case 'end':
          return 'end';

        case 'center':
          return 'center';

        case 'spaceBetween':
          return 'space-between';

        case 'spaceAround':
          return 'space-around';

        default:
          return 'start';
      }
    }
  }, {
    key: "alignItems",
    value: function alignItems(mainAxisAligment) {
      switch (mainAxisAligment) {
        case 'start':
          return 'start';

        case 'end':
          return 'end';

        case 'center':
          return 'center';

        case 'stretch':
          return 'stretch';

        default:
          return 'start';
      }
    }
  }, {
    key: "getTextStyle",
    value: function getTextStyle(properties) {
      var isRichSpan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _a;

      var defaultStyle = {
        fontSize: '12px',
        lineHeight: 1.2,
        color: '#242526'
      };
      var baseStyle = {
        textAlign: properties.get('textAlign'),
        color: properties.get('color'),
        fontSize: properties.get('fontSize') ? "".concat(px$1(properties.get('fontSize'))) : undefined,
        fontWeight: properties.get('fontWeight'),
        lineHeight: properties.get('lineHeight'),
        textDecoration: properties.get('decoration')
      };
      var maxLineStyle = {
        textOverflow: 'ellipsis',
        lineClamp: (_a = properties.get('maxLines')) !== null && _a !== void 0 ? _a : 1,
        display: '-webkit-box',
        boxOrient: 'vertical',
        overflow: 'hidden'
      };
      return isRichSpan ? baseStyle : Object.assign(Object.assign(Object.assign({}, defaultStyle), baseStyle), maxLineStyle);
    }
  }]);

  return PropertyConvert;
}();

var Renderer = /*#__PURE__*/function () {
  function Renderer() {
    _classCallCheck(this, Renderer);
  }

  _createClass(Renderer, null, [{
    key: "noTreeShaking",
    value: function noTreeShaking() {}
  }, {
    key: "createElement",
    value: function createElement(tag) {
      var _this = this;

      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var element = document.createElement(tag !== null && tag !== void 0 ? tag : 'div');
      Object.entries(props || {}).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        if (name.startsWith('on') && name.toLowerCase() in window) {
          var event = value;
          element.addEventListener(name.toLowerCase().substr(2), event);
        } else {
          element.setAttribute(name, value);
        }
      });

      for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        children[_key - 2] = arguments[_key];
      }

      children.forEach(function (child) {
        _this.appendChild(element, child);
      });
      return element;
    }
  }, {
    key: "appendChild",
    value: function appendChild(parent, child) {
      var _this2 = this;

      if (Array.isArray(child)) {
        child.forEach(function (nestedChild) {
          return _this2.appendChild(parent, nestedChild);
        });
      } else if (child !== null) {
        if (typeof child === 'string') {
          parent.appendChild(document.createTextNode(child));
        } else {
          parent.appendChild(child);
        }
      }
    }
  }]);

  return Renderer;
}();

Renderer.Fragment = function () {
  return document.createElement('div');
};

var CommonParser = /*#__PURE__*/function () {
  function CommonParser(factory) {
    _classCallCheck(this, CommonParser);

    this.factory = factory;
  }

  _createClass(CommonParser, [{
    key: "parse",
    value: function parse(properties) {
      var _this = this;

      var element = this.build(properties);

      if (properties.get('onClick')) {
        var onClick = properties.get('onClick');
        element.addEventListener('click', function () {
          var _a;

          (_a = _this.factory.eventHandle) === null || _a === void 0 ? void 0 : _a.handleEvent(onClick.toMap());
        });
      }

      return element;
    }
  }, {
    key: "buildChild",
    value: function buildChild(child) {
      if (child) {
        return this.parseChild(child);
      }

      return null;
    }
  }, {
    key: "buildChildren",
    value: function buildChildren(children) {
      var result = [];

      if (children !== null && Array.isArray(children)) {
        var _iterator = _createForOfIteratorHelper(children),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var c = _step.value;
            var w = this.parseChild(c);

            if (w) {
              result.push(w);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return result;
    }
  }, {
    key: "parseChild",
    value: function parseChild(child) {
      var parser = this.factory.createParser(child);

      if (parser) {
        try {
          return parser.parse(child);
        } catch (error) {
          console.error(error);
          throw Error('parseChild Error');
        }
      }

      throw Error('parseChild Error: Parser Not Found');
    }
  }, {
    key: "addStyle",
    value: function addStyle(sheet) {
      this.factory.styleSheets.add(sheet);
    }
  }]);

  return CommonParser;
}();

var jss = create();
jss.use(camelCase());
jss.use(nested());
jss.use(vendorPrefixer());

function createStyle(style) {
  var rule = jss.createRule(style, {});
  var styleObj = rule.style;
  var inlineStyleList = [];
  Object.keys(styleObj).forEach(function (key) {
    var value = styleObj[key];

    if (value !== undefined && value !== null) {
      inlineStyleList.push("".concat(key, ":").concat(styleObj[key]));
    }
  });
  return inlineStyleList.join(';');
}

var baseStyleSheet = jss.createStyleSheet({
  root: {},
  container: {},
  fixedContainer: {
    '& > $row': {
      width: '100%',
      height: '100%'
    },
    '& > $column': {
      width: '100%',
      height: '100%'
    }
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      boxSizing: 'border-box',
      width: '100%'
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    '& > div': {
      boxSizing: 'border-box',
      height: '100%'
    }
  },
  stack: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  button: {
    position: 'relative',
    backgroundClip: 'content-box',
    boxSizing: 'border-box',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    padding: '0 4px',
    textAlign: 'center',
    fontWeight: '500',
    backgroundColor: '#3FFF88',
    height: '28px',
    fontSize: '12px',
    color: '#242526',
    '&::before': {
      left: 0,
      right: 0,
      top: '4px',
      bottom: '4px',
      content: '""',
      display: 'block',
      position: 'absolute',
      backgroundColor: 'inherit'
    }
  },
  buttonInner: {
    position: 'relative',
    zIndex: 1,
    whiteSpace: 'nowrap',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    verticalAlign: 'middle'
  }
}, {
  classNamePrefix: 'kk-custom-ui__'
});

function px(num) {
  return "".concat(num, "px");
}

function getTimingFunction(timingFunction) {
  return timingFunction.replace(/([A-Z])/g, function (match, p1) {
    return "-".concat(p1.toLowerCase());
  });
}

function getRepeatCount(repeat) {
  if (repeat === -1) {
    return 'infinite';
  }

  if (typeof repeat === 'number') {
    return repeat;
  }

  return 1;
}

var AnimationHelper = /*#__PURE__*/function () {
  function AnimationHelper() {
    _classCallCheck(this, AnimationHelper);
  }

  _createClass(AnimationHelper, [{
    key: "genAnimationRule",
    value: function genAnimationRule(animationConfig, sheets) {
      var _a, _b;

      var animName = this.generateName(animationConfig.animations);
      var animation = {};

      for (var _i = 0, _Object$keys = Object.keys(animationConfig.animations); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var keyframe = this.getKeyframe(animationConfig.animations[key]);
        animation[key] = keyframe;
      }

      var jss$1 = jss.createStyleSheet(_defineProperty({}, "@keyframes ".concat(animName), animation));
      sheets.add(jss$1);
      return {
        'animation-name': jss$1.keyframes[animName],
        'animation-duration': "".concat(animationConfig.duration, "ms"),
        'animation-timing-function': getTimingFunction((_a = animationConfig.timingFunction) !== null && _a !== void 0 ? _a : 'linear'),
        'animation-iteration-count': getRepeatCount(animationConfig.repeat),
        'animation-delay': "".concat((_b = animationConfig.delay) !== null && _b !== void 0 ? _b : 0, "ms"),
        'animation-fill-mode': 'forwards'
      };
    }
  }, {
    key: "getKeyframe",
    value: function getKeyframe(style) {
      var content = {};
      var pxUnitProperties = ['width', 'height', 'left', 'right', 'top', 'bottom'];

      for (var _i2 = 0, _Object$keys2 = Object.keys(style); _i2 < _Object$keys2.length; _i2++) {
        var key = _Object$keys2[_i2];

        if (pxUnitProperties.includes(key)) {
          content[key] = px(style[key]);
        } else if (key === 'opacity') {
          content.opacity = style.opacity;
        }
      }

      return content;
    }
  }, {
    key: "generateName",
    value: function generateName(style) {
      var str = JSON.stringify(style);
      var hash = md5(str);
      return "anim_".concat(hash.slice(0, 8));
    }
  }]);

  return AnimationHelper;
}();

var animationHelper = new AnimationHelper();

var ContainerParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(ContainerParser, _CommonParser);

  var _super = _createSuper(ContainerParser);

  function ContainerParser() {
    _classCallCheck(this, ContainerParser);

    return _super.apply(this, arguments);
  }

  _createClass(ContainerParser, [{
    key: "match",
    value: function match(type) {
      return type === 'Container';
    }
  }, {
    key: "build",
    value: function build(properties) {
      var width = properties.get('width');
      var height = properties.get('height');
      var padding = properties.get('padding');
      var margin = properties.get('margin');
      var background = properties.get('background');
      var border = properties.get('border');
      var borderRadius = properties.get('borderRadius');
      var flex = properties.get('flex');
      var opacity = properties.get('opacity');
      var containerStyle = {
        overflow: 'hidden',
        boxSizing: 'border-box'
      };

      if (width) {
        containerStyle.width = px$1(width);
      }

      if (flex) {
        containerStyle.flex = flex;
      }

      if (height) {
        containerStyle.height = px$1(height);
      }

      if (padding) {
        containerStyle.padding = PropertyConvert.paddingValue(padding);
      }

      if (margin) {
        containerStyle.margin = PropertyConvert.paddingValue(margin);
      }

      if (border === null || border === void 0 ? void 0 : border.all) {
        containerStyle.border = PropertyConvert.borderValue(border.all);
      }

      if (border === null || border === void 0 ? void 0 : border.top) {
        containerStyle.borderTop = PropertyConvert.borderValue(border.top);
      }

      if (border === null || border === void 0 ? void 0 : border.right) {
        containerStyle.borderRight = PropertyConvert.borderValue(border.right);
      }

      if (border === null || border === void 0 ? void 0 : border.bottom) {
        containerStyle.borderBottom = PropertyConvert.borderValue(border.bottom);
      }

      if (border === null || border === void 0 ? void 0 : border.left) {
        containerStyle.borderLeft = PropertyConvert.borderValue(border.left);
      }

      if (borderRadius) {
        containerStyle.borderRadius = PropertyConvert.borderRadiusValue(borderRadius);
      }

      if (opacity !== undefined) {
        containerStyle.opacity = opacity;
      }

      if (background) {
        var color = background.get('color');
        var url = background.get('image');
        var fit = background.get('fit');

        if (color) {
          containerStyle.backgroundColor = PropertyConvert.hexAToRGBA(color);
        }

        if (url) {
          containerStyle.backgroundImage = "url('".concat(url, "')");
          containerStyle.backgroundColor = PropertyConvert.fitValue(fit);
        }
      }

      if (properties.get('animationConfig') && this.factory.showAnimation) {
        var animationRules = animationHelper.genAnimationRule(properties.get('animationConfig').node, this.factory.styleSheets);
        Object.assign(containerStyle, animationRules);
      }

      var styles = createStyle(containerStyle);
      var child = properties.get('child');
      return Renderer.createElement("div", {
        style: styles,
        "class": "".concat(baseStyleSheet.classes.container, " ").concat(baseStyleSheet.classes.fixedContainer)
      }, this.buildChild(child));
    }
  }]);

  return ContainerParser;
}(CommonParser);

var ImageParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(ImageParser, _CommonParser);

  var _super = _createSuper(ImageParser);

  function ImageParser() {
    _classCallCheck(this, ImageParser);

    return _super.apply(this, arguments);
  }

  _createClass(ImageParser, [{
    key: "match",
    value: function match(type) {
      return type === 'Image';
    }
  }, {
    key: "build",
    value: function build(properties) {
      var _this = this;

      var _a, _b;

      var url = (_a = properties.get('url')) !== null && _a !== void 0 ? _a : '';
      var fit = (_b = properties.get('fit')) !== null && _b !== void 0 ? _b : 'fill';
      var width = properties.get('width');
      var height = properties.get('height');
      var radius = properties.get('radius');
      var imageStyle = {
        display: 'block'
      };

      if (fit) {
        imageStyle.objectFit = fit;
      }

      if (width) {
        imageStyle.width = px$1(width);
      } else {
        imageStyle.width = '100%';
      }

      if (height) {
        imageStyle.height = px$1(height);
      } else {
        imageStyle.width = '100%';
      }

      if (radius) {
        imageStyle.borderRadius = px$1(radius);
      }

      var styles = createStyle(imageStyle);
      var element = Renderer.createElement("img", {
        style: styles,
        src: url,
        alt: ""
      });

      if (properties.get('canPreview')) {
        element.addEventListener('click', function () {
          var _a;

          (_a = _this.factory.eventHandle) === null || _a === void 0 ? void 0 : _a.handleEvent({
            action: 'preview',
            url: url
          });
        });
      }

      return element;
    }
  }]);

  return ImageParser;
}(CommonParser);

var TextParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(TextParser, _CommonParser);

  var _super = _createSuper(TextParser);

  function TextParser() {
    _classCallCheck(this, TextParser);

    return _super.apply(this, arguments);
  }

  _createClass(TextParser, [{
    key: "match",
    value: function match(type) {
      return type === 'Text';
    }
  }, {
    key: "build",
    value: function build(properties) {
      var _a;

      if (properties.get('rich')) {
        return this.buildRichText(properties, properties.get('rich'));
      }

      var styles = createStyle(PropertyConvert.getTextStyle(properties));
      var content = (_a = properties.get('content')) !== null && _a !== void 0 ? _a : '';
      return Renderer.createElement("span", {
        style: styles
      }, content);
    }
  }, {
    key: "buildRichSpan",
    value: function buildRichSpan(properties) {
      var _a;

      if (properties.get('rich')) {
        return this.buildRichText(properties, properties.get('rich'));
      }

      var styles = createStyle(PropertyConvert.getTextStyle(properties, true));
      var content = (_a = properties.get('content')) !== null && _a !== void 0 ? _a : '';
      return Renderer.createElement("span", {
        style: styles
      }, content);
    }
  }, {
    key: "buildRichText",
    value: function buildRichText(properties, rich) {
      var _this = this;

      var styles = createStyle(PropertyConvert.getTextStyle(properties));
      return Renderer.createElement("div", {
        style: styles
      }, rich.map(function (item) {
        return _this.buildRichSpan(item);
      }));
    }
  }]);

  return TextParser;
}(CommonParser);

var RootParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(RootParser, _CommonParser);

  var _super = _createSuper(RootParser);

  function RootParser() {
    _classCallCheck(this, RootParser);

    return _super.apply(this, arguments);
  }

  _createClass(RootParser, [{
    key: "build",
    value: function build(properties) {
      var styles = createStyle({
        backgroundColor: '#F9F9F9',
        borderRadius: '6px',
        overflow: 'hidden'
      });
      return Renderer.createElement(Renderer["Fragment()"], null, Renderer.createElement("div", {
        style: styles,
        "class": baseStyleSheet.classes.root
      }, this.buildChild(properties.get('child'))));
    }
  }, {
    key: "match",
    value: function match(type) {
      return type === 'Root';
    }
  }]);

  return RootParser;
}(CommonParser);

var RowParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(RowParser, _CommonParser);

  var _super = _createSuper(RowParser);

  function RowParser() {
    _classCallCheck(this, RowParser);

    return _super.apply(this, arguments);
  }

  _createClass(RowParser, [{
    key: "build",
    value: function build(properties) {
      var styles = createStyle({
        alignItems: PropertyConvert.alignItems(properties.get('crossAxisAlignment')),
        justifyContent: PropertyConvert.justifyContent(properties.get('mainAxisAlignment')),
        flex: properties.get('flex')
      });
      return Renderer.createElement("div", {
        style: styles,
        "class": baseStyleSheet.classes.row
      }, this.buildChildren(properties.get('children')));
    }
  }, {
    key: "match",
    value: function match(type) {
      return type === 'Row';
    }
  }]);

  return RowParser;
}(CommonParser);

var ColumnParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(ColumnParser, _CommonParser);

  var _super = _createSuper(ColumnParser);

  function ColumnParser() {
    _classCallCheck(this, ColumnParser);

    return _super.apply(this, arguments);
  }

  _createClass(ColumnParser, [{
    key: "build",
    value: function build(properties) {
      var styles = createStyle({
        alignItems: PropertyConvert.alignItems(properties.get('crossAxisAlignment')),
        justifyContent: PropertyConvert.justifyContent(properties.get('mainAxisAlignment')),
        flex: properties.get('flex')
      });
      return Renderer.createElement("div", {
        style: styles,
        "class": baseStyleSheet.classes.column
      }, this.buildChildren(properties.get('children')));
    }
  }, {
    key: "match",
    value: function match(type) {
      return type === 'Column';
    }
  }]);

  return ColumnParser;
}(CommonParser);

var StackParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(StackParser, _CommonParser);

  var _super = _createSuper(StackParser);

  function StackParser() {
    _classCallCheck(this, StackParser);

    return _super.apply(this, arguments);
  }

  _createClass(StackParser, [{
    key: "match",
    value: function match(type) {
      return type === 'Stack';
    }
  }, {
    key: "build",
    value: function build(properties) {
      return Renderer.createElement("div", {
        "class": baseStyleSheet.classes.stack
      }, this.buildChildren(properties.get('children')));
    }
  }]);

  return StackParser;
}(CommonParser);

var PositionedParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(PositionedParser, _CommonParser);

  var _super = _createSuper(PositionedParser);

  function PositionedParser() {
    _classCallCheck(this, PositionedParser);

    return _super.apply(this, arguments);
  }

  _createClass(PositionedParser, [{
    key: "match",
    value: function match(type) {
      return type === 'Positioned';
    }
  }, {
    key: "build",
    value: function build(properties) {
      var _a, _b, _c, _d;

      var child = properties.get('child');
      var top = (_a = properties.get('top')) !== null && _a !== void 0 ? _a : 0;
      var right = (_b = properties.get('right')) !== null && _b !== void 0 ? _b : 0;
      var bottom = (_c = properties.get('bottom')) !== null && _c !== void 0 ? _c : 0;
      var left = (_d = properties.get('left')) !== null && _d !== void 0 ? _d : 0;
      var positionedStyle = {
        position: 'absolute'
      };

      if (top !== 0 || top === 0 && bottom === 0) {
        positionedStyle.top = px$1(top);
      }

      if (right !== 0) {
        positionedStyle.right = px$1(right);
      }

      if (bottom !== 0) {
        positionedStyle.bottom = px$1(bottom);
      }

      if (left !== 0 || left === 0 && right === 0) {
        positionedStyle.left = px$1(left);
      }

      if (properties.get('animationConfig') && this.factory.showAnimation) {
        var animationRules = animationHelper.genAnimationRule(properties.get('animationConfig').node, this.factory.styleSheets);
        Object.assign(positionedStyle, animationRules);
      }

      var styles = createStyle(positionedStyle);
      return Renderer.createElement("div", {
        style: styles
      }, this.buildChild(child));
    }
  }]);

  return PositionedParser;
}(CommonParser);

var ButtonParser = /*#__PURE__*/function (_CommonParser) {
  _inherits(ButtonParser, _CommonParser);

  var _super = _createSuper(ButtonParser);

  function ButtonParser() {
    _classCallCheck(this, ButtonParser);

    return _super.apply(this, arguments);
  }

  _createClass(ButtonParser, [{
    key: "build",
    value: function build(properties) {
      var _a;

      var buttonStyle = {
        width: properties.get('width') ? px$1(properties.get('width')) : undefined
      };
      var textStyle = {};

      if (properties.get('style')) {
        textStyle = PropertyConvert.getTextStyle(properties.get('style'), true);
      }

      if (properties.get('color')) {
        buttonStyle.backgroundColor = properties.get('color');
      }

      var styles = createStyle(buttonStyle);
      var textStyles = createStyle(textStyle);
      return Renderer.createElement("button", {
        "class": baseStyleSheet.classes.button,
        style: styles
      }, Renderer.createElement("span", {
        "class": baseStyleSheet.classes.buttonInner,
        style: textStyles
      }, (_a = properties.get('text')) !== null && _a !== void 0 ? _a : ''));
    }
  }, {
    key: "match",
    value: function match(type) {
      return type === 'KKButton';
    }
  }]);

  return ButtonParser;
}(CommonParser);

var UiEventHandle = /*#__PURE__*/function () {
  function UiEventHandle(handleFunction) {
    _classCallCheck(this, UiEventHandle);

    this.handleFunction = handleFunction;
  }

  _createClass(UiEventHandle, [{
    key: "handleEvent",
    value: function handleEvent(param) {
      if (this.handleFunction) {
        this.handleFunction(param);
      }
    }
  }]);

  return UiEventHandle;
}();

var WidgetParserFactory = /*#__PURE__*/function () {
  function WidgetParserFactory(options) {
    _classCallCheck(this, WidgetParserFactory);

    this.eventHandle = new UiEventHandle(options.eventHandler);
    this.showAnimation = options.showAnimation;
  }

  _createClass(WidgetParserFactory, [{
    key: "createParser",
    value: function createParser(dsl) {
      var type = dsl.get('type');

      if (type !== undefined) {
        var _iterator = _createForOfIteratorHelper(WidgetParserFactory.parserBuilderList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var parserBuilder = _step.value;
            var parser = parserBuilder(this);

            if (parser.match(type)) {
              return parser;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      throw Error("Cannot find type of \"".concat(type, "\" for parsing widget! properties: $dsl"));
    }
  }, {
    key: "styleSheets",
    get: function get() {
      return WidgetParserFactory.styleSheets;
    }
  }]);

  return WidgetParserFactory;
}();
WidgetParserFactory.parserBuilderList = [function (factory) {
  return new ContainerParser(factory);
}, function (factory) {
  return new TextParser(factory);
}, function (factory) {
  return new ImageParser(factory);
}, function (factory) {
  return new RootParser(factory);
}, function (factory) {
  return new RowParser(factory);
}, function (factory) {
  return new ColumnParser(factory);
}, function (factory) {
  return new StackParser(factory);
}, function (factory) {
  return new PositionedParser(factory);
}, function (factory) {
  return new ButtonParser(factory);
}];
WidgetParserFactory.styleSheets = new SheetsRegistry();

var statementReg = /{{(.*?)}}/;
var valueReg = /{{(.*?)}}/g;
var forReg = /for(\w+)in(\w+)/;
var forWithIndexReg = /for\((\w+),(\w+)\)in(\w+)/;
var ifReg = /^if\((.*?)(>|<|==)+(.*?)\)/;
var ifKeyReg = /^{{(else)?\s*if\((.+)(>|<|==)+(.+)\)}}/;
var elseReg = /^{{else}}/;
var lengthReg = /length\((.*?)\)/;
var numberReg = /^[\d]+$/;
var mathExpReg = /^\+{{(.*)}}$/;
function templateAnalysis(templateNode, dataContext, parentNode) {
  try {
    var entries = Object.entries(templateNode);

    for (var _i = 0, _entries = entries; _i < _entries.length; _i++) {
      var item = _entries[_i];
      var matchKey = item[0].match(statementReg);

      if (matchKey) {
        var result = handleKeys(matchKey[1], item[1], dataContext, templateNode);

        if (Array.isArray(result)) {
          var resultList = [];

          var _iterator = _createForOfIteratorHelper(result),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _item = _step.value;
              resultList.push(templateAnalysis(_item, dataContext, templateNode));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return resultList;
        }

        if (result) {
          var _iterator2 = _createForOfIteratorHelper(entries),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _entry = _step2.value;
              delete templateNode[_entry[0]];
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var resultEntries = Object.entries(result);

          for (var _i2 = 0, _resultEntries = resultEntries; _i2 < _resultEntries.length; _i2++) {
            var entry = _resultEntries[_i2];
            templateNode[entry[0]] = entry[1];
          }

          return templateAnalysis(templateNode, dataContext, parentNode);
        }

        return null;
      }

      if (typeof item[1] === 'string') {
        var r = void 0;

        if (r = mathExpReg.exec(item[1])) {
          var _result = handleMathExpression(r[1], dataContext);

          templateNode[item[0]] = _result;
        } else {
          templateNode[item[0]] = handleStr(item[1], dataContext);
        }
      } else if (Array.isArray(item[1])) {
        var array = item[1];
        var _result2 = [];

        var _iterator3 = _createForOfIteratorHelper(array),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var child = _step3.value;

            if (typeof child === 'string') {
              _result2.push(handleStr(child, dataContext));
            }

            if (_typeof(child) === 'object') {
              var resultNode = templateAnalysis(child, dataContext, templateNode);

              if (Array.isArray(resultNode)) {
                var _iterator4 = _createForOfIteratorHelper(resultNode),
                    _step4;

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _item2 = _step4.value;

                    if (_item2) {
                      _result2.push(_item2);
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              } else {
                if (resultNode) {
                  _result2.push(templateAnalysis(child, dataContext, templateNode));
                }
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        templateNode[item[0]] = _result2;
      } else if (_typeof(item[1]) === 'object') {
        templateNode[item[0]] = templateAnalysis(item[1], dataContext, templateNode);
      }
    }

    return templateNode;
  } catch (e) {
    console.log("template analysis error: ".concat(e));
    throw e;
  }
}

function handleStr(str, dataContext) {
  var valueTemp = str.replace(/\s*/g, '');

  var matchValues = _toConsumableArray(valueTemp.matchAll(valueReg));

  var valueResult = valueTemp;

  var _iterator5 = _createForOfIteratorHelper(matchValues),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var matchValue = _step5.value;

      if (matchValue) {
        var lengthMatch = matchValue[1].match(lengthReg);

        if (lengthMatch) {
          var lengthResult = handleLength(lengthMatch[1], dataContext);
          matchValue[1] = matchValue[1].replace(lengthReg, lengthResult);
          valueResult = valueResult[1].replace(statementReg, matchValue[1]);
        } else {
          var valueStrList = matchValue[1].split('.');
          var tempValue = dataContext;

          var _iterator6 = _createForOfIteratorHelper(valueStrList),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var key = _step6.value;
              tempValue = tempValue[key];
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          if (tempValue !== undefined && tempValue !== null) {
            valueResult = valueResult.replace(statementReg, tempValue.toString());
          }
        }
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return valueResult;
}

function handleMathExpression(str, dataContext) {
  var mathPattern = /^\s?([+\-*/])\s?([0-9a-zA-Z.]+)\s?/;
  var preMathPattern = /^\s?([0-9a-zA-Z.]+)\s?/;
  var numStack = [];
  var opStack = [];
  var tempStr = str;
  var r = preMathPattern.exec(tempStr);

  if (r) {
    var numStr = r[1];

    if (!/\d+/.test(numStr)) {
      numStr = handleStr("{{".concat(numStr, "}}"), dataContext);
    }

    numStack.push(parseInt(numStr, 10));
    tempStr = tempStr.slice(r[0].length);
  }

  while (r = mathPattern.exec(tempStr)) {
    var op = r[1];
    var _numStr = r[2];

    if (!/\d+/.test(_numStr)) {
      _numStr = handleStr("{{".concat(_numStr, "}}"), dataContext);
    }

    var num = parseInt(_numStr, 10);
    var preNum = void 0;

    switch (op) {
      case '+':
      case '-':
        numStack.push(num);
        opStack.push(op);
        break;

      case '*':
        preNum = numStack.pop();
        numStack.push(preNum * num);
        break;

      case '/':
        preNum = numStack.pop();
        numStack.push(preNum / num);
        break;
    }

    tempStr = tempStr.slice(r[0].length);
  }

  var result = numStack.shift();

  while (numStack.length > 0) {
    var _num = numStack.shift();

    var _op = opStack.shift();

    switch (_op) {
      case '+':
        result = result + _num;
        break;

      case '-':
        result = result - _num;
        break;
    }
  }

  return result;
}

function handleKeys(key, node, dataContext, parentNode) {
  var keyTemp = key.replace(/\s*/g, '');
  var forMatch = keyTemp.match(forReg);

  if (forMatch) {
    return handleFor(node, dataContext, forMatch[1], forMatch[2], parentNode);
  }

  var forWithIndexMatch = keyTemp.match(forWithIndexReg);

  if (forWithIndexMatch) {
    return handleFor(node, dataContext, forWithIndexMatch[1], forWithIndexMatch[3], parentNode, forWithIndexMatch[2]);
  }

  var ifMatch = keyTemp.match(ifReg);

  if (ifMatch) {
    return handleIf(parentNode, dataContext);
  }

  return null;
}

function handleFor(node, dataContext, keyName, dataName, parentNode, indexName) {
  var data = dataContext[dataName];

  if (Array.isArray(data)) {
    var dataLength = data.length;
    var resultList = [];

    for (var i = 0; i < dataLength; i++) {
      var tempDataContext = JSON.parse(JSON.stringify(dataContext));
      var tempNode = JSON.parse(JSON.stringify(node));
      tempDataContext[keyName] = data[i];

      if (indexName) {
        tempDataContext[indexName] = i;
      }

      var result = templateAnalysis(tempNode, tempDataContext, parentNode);

      if (result) {
        resultList.push(result);
      }
    }

    return resultList;
  }

  throw Error("template error: ".concat(dataName, " is not list"));
}

function handleIf(parentNode, dataContext) {
  var keys = Object.keys(parentNode);

  for (var _i3 = 0, _keys = keys; _i3 < _keys.length; _i3++) {
    var item = _keys[_i3];
    var node = parentNode[item];
    var itemTemp = item.replace(/\s*/g, '');
    var itemMatch = itemTemp.match(ifKeyReg);

    if (itemMatch) {
      var result = ifCase(node, dataContext, itemMatch[2], itemMatch[3], itemMatch[4]);

      if (result) {
        return templateAnalysis(result, dataContext, parentNode);
      }
    }

    var elseMatch = item.match(elseReg);

    if (elseMatch) {
      return templateAnalysis(node, dataContext, parentNode);
    }
  }

  return null;
}

function ifCase(node, dataContext, paramA, operate, paramB) {
  var paramAValue = getValue(paramA, dataContext);
  var paramBValue = getValue(paramB, dataContext);

  switch (operate) {
    case '<':
      {
        if (paramAValue < paramBValue) {
          return node;
        }

        break;
      }

    case '>':
      {
        if (paramAValue > paramBValue) {
          return node;
        }

        break;
      }

    case '==':
      {
        if (paramAValue === paramBValue) {
          return node;
        }

        break;
      }
  }

  return null;
}

function getValue(value, dataContext) {
  var lengthMatch = value.match(lengthReg);

  if (lengthMatch) {
    return handleLength(lengthMatch[1], dataContext);
  }

  if (!value.match(numberReg)) {
    var tempValue = dataContext;
    var valueStrList = value.split('.');

    var _iterator7 = _createForOfIteratorHelper(valueStrList),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var key = _step7.value;
        tempValue = tempValue[key];
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    return tempValue.toString();
  }

  return Number(value).toString();
}

function handleLength(dataName, dataContext) {
  var tempValue = dataContext;
  var valueStrList = dataName.split('.');

  var _iterator8 = _createForOfIteratorHelper(valueStrList),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var key = _step8.value;
      tempValue = tempValue[key];
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  if (Array.isArray(tempValue)) {
    return tempValue.length.toString();
  }

  throw Error("length analysis error: ".concat(dataName, " is not array"));
}

function jsonCompress(json) {
  var obj = JSON.parse(json);
  var abbrMap = PropertyNode.abbrMap;
  var reversedAbbrMap = {};
  Object.keys(abbrMap).forEach(function (key) {
    var value = abbrMap[key];
    reversedAbbrMap[value] = key;
  });
  var targetObj = camelizeKeys(obj, function (key) {
    if (key in reversedAbbrMap) {
      return reversedAbbrMap[key];
    }

    return key;
  });
  return JSON.stringify(targetObj);
}

var util = /*#__PURE__*/Object.freeze({
  __proto__: null,
  jsonCompress: jsonCompress
});

var KKCustomUI = /*#__PURE__*/function () {
  function KKCustomUI(options) {
    _classCallCheck(this, KKCustomUI);

    this.options = options;
  }

  _createClass(KKCustomUI, [{
    key: "build",
    value: function build(el, content) {
      var _a;

      var factory = new WidgetParserFactory({
        eventHandler: (_a = this.options) === null || _a === void 0 ? void 0 : _a.eventHandler,
        showAnimation: this.options.showAnimation
      });
      var dsl = new PropertyNode(content);
      var parser = factory.createParser(dsl);
      var child = parser.parse(dsl);
      var shadow = el.attachShadow({
        mode: 'open'
      });
      factory.styleSheets.add(baseStyleSheet);
      var style = document.createElement('style');
      style.innerHTML = factory.styleSheets.toString();
      shadow.appendChild(style);
      shadow.appendChild(child);
    }
  }, {
    key: "buildFromTemplate",
    value: function buildFromTemplate(el, template, data) {
      var content = templateAnalysis(template, data);

      if (content !== null) {
        this.build(el, content);
      }

      return content;
    }
  }]);

  return KKCustomUI;
}();

export { KKCustomUI, KKCustomUI as default, util };
